import { render, staticRenderFns } from "./Peers.vue?vue&type=template&id=3cc0f8b4"
import script from "./Peers.vue?vue&type=script&lang=js"
export * from "./Peers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports